/**
 * QR-redirects
 *
 * Deze lijst vervangt de oude WordPress QR-plugin. Elke sleutel is het laatste
 * stukje van de URL achter /blog/qr/ — precies zoals die op de gedrukte QR-code
 * staat. De waarde is de bestemming waar de bezoeker naartoe wordt gestuurd.
 *
 * Nieuwe QR-code nodig? Zet hier een regel bij, meer is niet nodig:
 *   'naam-van-de-klant': 'https://website-van-de-klant.nl/'
 *
 * LET OP: bestaande sleutels nooit hernoemen of verwijderen. Die staan op
 * gedrukt materiaal en visitekaartjes; zodra de sleutel weg is, is de QR-code
 * dood.
 */
export interface QrRedirect {
  /** Waar de bezoeker naartoe gaat. Altijd volledige URL inclusief https:// */
  target: string;
  /** Naam van de klant, puur ter herkenning in deze lijst. */
  label: string;
}
export const qrRedirects: Record<string, QrRedirect> = {
  'het-overnamehuys': {
    target: 'https://hetovernamehuys.nl/',
    label: 'Het Overnamehuys'
  }
};
/**
 * Zoekt een redirect op. Hoofdletterongevoelig en tolerant voor een
 * afsluitende slash, zodat scanners die de URL net iets anders doorgeven
 * alsnog goed uitkomen.
 */
export function findQrRedirect(slug?: string): QrRedirect | undefined {
  if (!slug) return undefined;
  const normalized = slug.trim().toLowerCase().replace(/\/+$/, '');
  return qrRedirects[normalized];
}
